import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withPlayerMessageConfiguration
    from "../../core/components/playerMessage/configuration/withPlayerMessageConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import PIXI from "pixi.js";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { CURRENCY, TIMER } from "../../core/utills";
import { actions as showMessageActions } from "../../core/reducers/playerMessageReducer";
import { actions as behaviourAction } from "../../gamereducer/behaviourReducer";
import { actions as winCelebrationActions } from "../../gamereducer/winCelebrationReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as basegameActions } from "../../core/reducers/baseGameReducer";
import { Next } from "react-bootstrap/PageItem";

interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;

}

interface IStateToProps {

    layoutMode: string;
    selectContainer: string;
    buyInFeatureDeductAmt: number;
    leftMessageIndex: number;
    rightMessageIndex: number;
    pauseInterval: boolean;
    resumeInterval: boolean;
    startInterval: boolean;
    insufficientFunds: boolean;
    leftContainerIntervalTime: number;
    rightContainerIntervalTime: number;
    sessionTimer: any;
    spinStart: any;
    allSpinComplete: any;
    betList: any;
    currentBetIndex: any;
    selectedCoin: any;
    displayInCoins: any;
    inFreeGame: any;
    coinList: any;
    winAmount: any;
    balance: any;
    allButtonEnable: any;
    transitionBalance: any;
    previousBalance: any;
    increaseBetResult: any;
    winAmountEmpty: any;
    basegamestate: any;
    totalCreditWinAmount: any;
    buyFeatureStakeExceeds: any;
    fgSpinWinAmount: any;
    callFlowManager: any;
    isRequestSent: any;
    blastStart: any;
    hasBalance: boolean;
    addOnBalance: number;
    hasCapped: any,
}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class GamePlayerMessage extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected gamePlayerMessageContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;
    protected leftContainerChildCurrentIndex: number;
    protected rightContainerChildCurrentIndex: number;
    protected leftInterval: any;
    protected rightInterval: any;
    protected messagesRunInLoopLeftContainer: any;
    protected messagesNotRunInLoopLeftContainer: any;
    protected messagesRunInLoopRightContainer: any;
    protected messagesNotRunInLoopRightContainer: any;
    protected betValueText: any;
    protected totalTetValueText: any;
    protected coinValueText: any;
    protected balanceValueText: any;
    protected winValueText: any;
    protected betPanelLableValue: any
    protected coinValueDivider: number = 2000;
    protected constantT1: number = 1;
    protected winValueStore: number = 0;
    protected winCelebrationMinimumValue: number = 25;
    protected storedFinalAmount: number = 0;



    protected totalCoins: any;
    protected coinsWon: any;
    protected singleCoinValue: any;
    protected coinContainer_totalWin: any;
    protected coinContainer_Bet: any;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            leftContainer: false,
            rightContainer: false,
            uiElements: [],
            lang: "en"
        }
        this.gamePlayerMessageContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.child.filter(this.checkUiMode.bind(this))
        this.leftContainerChildCurrentIndex = 0;
        this.rightContainerChildCurrentIndex = 0;
        this.messagesRunInLoopLeftContainer = [];
        this.messagesNotRunInLoopLeftContainer = [];
        this.messagesRunInLoopRightContainer = [];
        this.messagesNotRunInLoopRightContainer = [];
        this.displayUI.map((data: any) => {
            if (data.name === "leftInfoContainer") {
                for (let i = 0; i < data.child.length; i++) {
                    if (data.child[i].messageInLoop) {
                        this.messagesRunInLoopLeftContainer.push(data.child[i]);
                    } else {
                        this.messagesNotRunInLoopLeftContainer.push(data.child[i]);
                    }
                }
            } else if (data.name === "rightInfoContainer") {
                for (let i = 0; i < data.child.length; i++) {
                    if (data.child[i].messageInLoop) {
                        this.messagesRunInLoopRightContainer.push(data.child[i]);
                    } else {
                        this.messagesNotRunInLoopRightContainer.push(data.child[i]);
                    }
                }
            }
        })
    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    alignContainer() {



        let totalWinTextContainer: any = UIManager.getRef("container_basegame_text3");

        totalWinTextContainer && UIManager.alignChildren("container_basegame_text3", "left")

        let currencyContainer2: any = UIManager.getRef("container_basegame_text2");

        currencyContainer2 && UIManager.alignChildren("container_basegame_text2", "right")

        let coinContainer2: any = UIManager.getRef("container_basegame_text_balance");

        coinContainer2 && UIManager.alignChildren("container_basegame_text_balance", "right")

        let currencyContainer1: any = UIManager.getRef("container_basegame_text1");

        currencyContainer1 && UIManager.alignChildren("container_basegame_text1", "left")

        let coinContainer1: any = UIManager.getRef("container_basegame_text_bet_coins");

        coinContainer1 && UIManager.alignChildren("container_basegame_text_bet_coins", "left")

        let coinwinContainer1: any = UIManager.getRef("container_label_coins");

        coinwinContainer1 && UIManager.alignChildren("container_label_coins", "left")
    }
    correctCurrencyCodeXAF(amount: string) {
        if ((window as any).GAME_INFO.currency == "XAF") {
            return amount.replace('F', 'FCFA');
        }
        if ((window as any).GAME_INFO.currency == "XOF") {
            return amount.replace('F', 'XOF');
        }
        return amount;
    }
    bindUI() {
        // setTimeout(()=>{
        //     let balanceValueInCurrency = CURRENCY.CurrencyManager.formatCurrencyString((123456788), true, true, true, true);

        //     this.alignContainer();
        // },5000)
        this.layoutChange(this.props.layoutMode);
        this.betValueText && (this.betValueText.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true)));
        this.betPanelLableValue && (this.betPanelLableValue.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true)));
        this.coinValueText && (this.coinValueText.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.props.coinList[this.props.selectedCoin] / this.coinValueDivider, true, true, true, true)));
        let balanceValueInCurrency = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.props.balance, true, true, true, true));
        UIManager.getRef("label_BetPanel_value") && (UIManager.setText("label_BetPanel_value", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true))));
        UIManager.getRef("coinContainer_text_total_bet_value") && (UIManager.setText("coinContainer_text_total_bet_value", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true))));
        UIManager.getRef("coinContainer_text_win_value1_desktop") && (UIManager.setText("coinContainer_text_win_value1_desktop", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(0, true, true, true, true))));


        if (isMobile) {
            if (window.innerWidth < window.innerHeight) {
                UIManager.getRef("text_total_bet_value_portrait") && (UIManager.setText("text_total_bet_value_portrait", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true))));

                UIManager.getRef("text_Balance_value_withSign_portrait") && (UIManager.setText("text_Balance_value_withSign_portrait", balanceValueInCurrency));
            }
            else {
                UIManager.getRef("text_Balance_value_withSign_landscape") && (UIManager.setText("text_Balance_value_withSign_landscape", balanceValueInCurrency));
                UIManager.getRef("text_total_bet_value_landscape") && (UIManager.setText("text_total_bet_value_landscape", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true))));

                UIManager.getRef("text_win_value1_landscape") && (UIManager.setText("text_win_value1_landscape", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.props.winAmount, true, true, true, true))));

            }

        }
        else {
            //(this.totalTetValueText.text = CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true));
            UIManager.getRef("text_total_bet_value") && (UIManager.setText("text_total_bet_value", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true))));

            UIManager.getRef(this.balanceValueText) && (UIManager.setText(this.balanceValueText, balanceValueInCurrency));
            UIManager.getRef("text_win_value1") && (UIManager.setText("text_win_value1", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.props.winAmount, true, true, true, true))));

        }


        this.alignContainer();

    }

    //this method will initialize the object to variable

    initializeObjectToVariable() {
        this.totalTetValueText = UIManager.getRef("text_total_bet_value");
        this.betValueText = UIManager.getRef("text_bet_value");
        this.coinValueText = UIManager.getRef("text_Coin_value_value");
        this.betPanelLableValue = UIManager.getRef("label_BetPanel_value");
        this.balanceValueText = "text_Balance_value_withSign";
        this.winValueText = "text_win_value1";

        // Coins Container initialization
        this.totalCoins = UIManager.getRef("coinContainer_total_coins_value");
        this.coinsWon = UIManager.getRef("coinContainer_coin_win_value1_desktop");
        this.singleCoinValue = UIManager.getRef("coinContainer_coins_value_text");
        this.coinContainer_totalWin = UIManager.getRef("coinContainer_text_win_value1_desktop");
        this.coinContainer_Bet = UIManager.getRef("coinContainer_text_total_bet_value");
        this.setGameClockTime();
    }

    assignValuesToCoinContainer() {

        this.totalCoins && (this.totalCoins.text = Math.round(this.props.balance * 10 / this.props.coinList[this.props.selectedCoin]));

        this.totalCoins && (UIManager.setText("coinContainer_total_coins_value", Math.round(this.props.balance * 10 / this.props.coinList[this.props.selectedCoin])))
        this.coinsWon && (UIManager.setText("coinContainer_coin_win_value1_desktop", 0))
        UIManager.getRef("coinContainer_coin_win_value1") && (UIManager.setText("coinContainer_coin_win_value1", 0))

        this.coinContainer_totalWin && (this.coinContainer_totalWin.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(0.00, true, true, true, true)));
        this.singleCoinValue && (this.singleCoinValue.text = "10")
        this.coinContainer_Bet && (this.coinContainer_Bet.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true)));
        //this.coinContainer_Bet && (UIManager.setText("coinContainer_text_total_bet_value", Math.round(this.props.coinList[this.props.selectedCoin])));

    }

    handleInMobile() {

    }

    componentDidMount() {
        this.initializeObjectToVariable();
        this.bindUI();
        this.assignValuesToCoinContainer();
    }

    //this method will change the left container state

    changeLeftContent() {
        if (this.state.leftContainer) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    leftContainer: false,
                }
            })
        } else {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    leftContainer: true,
                }
            })
        }
    }

    //this method will change the right container state
    changeRightContent() {
        if (this.state.rightContainer) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    rightContainer: false,
                }
            })
        } else {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    rightContainer: true,
                }
            })
        }
    }


    //when layout changes, this methhod will be called
    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any, j: number) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        );
        if (isMobile) {
            let balanceValueInCurrency = CURRENCY.CurrencyManager.formatCurrencyString(this.props.balance, true, true, true, true);

            if (window.innerWidth < window.innerHeight) {
                UIManager.getRef("text_total_bet_value_portrait") && (UIManager.setText("text_total_bet_value_portrait", this.correctCurrencyCodeXAF(this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true)))));

                UIManager.getRef("text_Balance_value_withSign_portrait") && (UIManager.setText("text_Balance_value_withSign_portrait", balanceValueInCurrency));
            }
            else {
                UIManager.getRef("text_Balance_value_withSign_landscape") && (UIManager.setText("text_Balance_value_withSign_landscape", balanceValueInCurrency));

                UIManager.getRef("text_total_bet_value_landscape") && (UIManager.setText("text_total_bet_value_landscape", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[this.props.selectedCoin]), true, true, true, true))));
                UIManager.getRef("text_win_value1_landscape") && (UIManager.setText("text_win_value1_landscape", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.props.winAmount, true, true, true, true))));
                this.alignContainer();
            }


            let timer = TIMER.TimerManager.createTimer(5);
            timer.on('end', (e: any) => {
                this.handleOnLayoutChange(this.props.displayInCoins);
            })
            timer.start();


        }
        if (this.props.insufficientFunds) {
            let timer = TIMER.TimerManager.createTimer(5);
            timer.on('end', (e: any) => {
                this.showInsufficientFunds(true);
            })
            timer.start();

        }
        if (this.props.buyFeatureStakeExceeds) {
            let timer = TIMER.TimerManager.createTimer(5);
            timer.on('end', (e: any) => {
                this.showBuyFeatureStakeExceeds(true);
            })
            timer.start();

        }

    }

    //this method will change the left container text
    leftContainerChanging() {
        this.messagesRunInLoopLeftContainer.map((data: any, index: number) => {
            data.visible = false
            if (this.leftContainerChildCurrentIndex === this.messagesRunInLoopLeftContainer.length) {
                this.leftContainerChildCurrentIndex = 0;
            }
        })
        this.messagesRunInLoopLeftContainer[this.leftContainerChildCurrentIndex] && (this.messagesRunInLoopLeftContainer[this.leftContainerChildCurrentIndex].visible = true);
        this.leftContainerChildCurrentIndex++;
    }

    //to start the interval, call this method
    startInterval(nextProps: any) {
        if (nextProps.selectContainer === "both" || nextProps.selectContainer === "left") {
            this.changeLeftContent.call(this);
            let timer = TIMER.TimerManager.createTimer(this.props.leftContainerIntervalTime);
            timer.on('repeat', (i: number) => {
                this.changeLeftContent();
                if (nextProps.pauseInterval) {
                    timer.stop();
                    this.pauseInterval(nextProps);
                }
            });
            timer.start(true, this.props.leftContainerIntervalTime);
        }
        if (nextProps.selectContainer === "both" || nextProps.selectContainer === "right") {
            this.changeRightContent.call(this);
            let timer = TIMER.TimerManager.createTimer(this.props.rightContainerIntervalTime);
            timer.on('repeat', (i: number) => {
                this.changeRightContent();
                if (nextProps.pauseInterval) {
                    timer.stop();
                    this.pauseInterval(nextProps);
                }
            });
            timer.start(true, this.props.rightContainerIntervalTime);
        }
    }

    //this method will pause the text
    pauseInterval(nextProps: any) {
        if (nextProps.selectContainer === "both" || nextProps.selectContainer === "left") {
            this.displayUI.map((data: any) => {
                if (data.name === "leftInfoContainer") {
                    for (let i = 0; i < data.child.length; i++) {
                        data.child[i].visible = false;
                    }
                    data.child[this.leftContainerChildCurrentIndex].visible = true;
                }
            })
        }
        if (nextProps.selectContainer === "both" || nextProps.selectContainer === "right") {
            this.displayUI.map((data: any) => {
                if (data.name === "rightInfoContainer") {
                    for (let i = 0; i < data.child.length; i++) {
                        data.child[i].visible = false;
                    }
                    data.child[this.rightContainerChildCurrentIndex].visible = true;

                }
            })
        }
        this.props.pauseTheInterval(false);
    }

    //this method will resume movement of text after pause
    resumeInterval(nextProps: any) {
        this.displayUI.map((data: any) => {
            if (nextProps.selectContainer === "both" || nextProps.selectContainer === "left") {
                if (data.name === "leftInfoContainer") {
                    for (let i = 0; i < data.child.length; i++) {
                        data.child[i].visible = false;
                    }
                    this.changeLeftContent.call(this);
                    let timer = TIMER.TimerManager.createTimer(this.props.leftContainerIntervalTime);
                    timer.on('repeat', (i: number) => {

                        this.changeLeftContent();
                        if (nextProps.pauseInterval) {
                            timer.stop();
                            this.pauseInterval(nextProps);
                        }
                    });
                    timer.start(true, this.props.leftContainerIntervalTime);
                }
            }
            if (nextProps.selectContainer === "both" || nextProps.selectContainer === "right") {
                if (data.name === "rightInfoContainer") {
                    for (let i = 0; i < data.child.length; i++) {
                        data.child[i].visible = false;
                    }
                    this.changeRightContent.call(this);
                    let timer = TIMER.TimerManager.createTimer(this.props.rightContainerIntervalTime);
                    timer.on('repeat', (i: number) => {
                        this.changeRightContent();
                        if (nextProps.pauseInterval) {
                            timer.stop();
                            this.pauseInterval(nextProps);
                        }
                    });
                    timer.start(true, this.props.rightContainerIntervalTime);
                }
            }
        })
    }

    //this method will change the right container text
    rightContainerChanging(nextState: any) {
        this.messagesRunInLoopRightContainer.map((data: any, index: number) => {
            data.visible = false;
            if (this.rightContainerChildCurrentIndex === this.messagesRunInLoopRightContainer.length) {
                this.rightContainerChildCurrentIndex = 0;
            }
        })
        this.messagesRunInLoopRightContainer[this.rightContainerChildCurrentIndex] && (this.messagesRunInLoopRightContainer[this.rightContainerChildCurrentIndex].visible = true);
        this.rightContainerChildCurrentIndex++;
    }

    updateValues(nextProps: any) {
        //WHEN SPIN START DEDUCT BALANCE;
        let balanceValueInCurrency = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.balance), true, true, true, true));

        if (nextProps.basegamestate) {

            if (isMobile) {
                if (window.innerWidth < window.innerHeight) {
                    UIManager.getRef("text_Balance_value_withSign_portrait") && (UIManager.setText("text_Balance_value_withSign_portrait", balanceValueInCurrency));
                }
                else {
                    UIManager.getRef("text_Balance_value_withSign_landscape") && (UIManager.setText("text_Balance_value_withSign_landscape", balanceValueInCurrency));
                    this.alignContainer();
                }

            }
            else {
                UIManager.getRef(this.balanceValueText) && (UIManager.setText(this.balanceValueText, balanceValueInCurrency));
                this.alignContainer();

            }


        } else {
        }


        //this.props.setApplicationBalance(this.props.balance - nextProps.coinList[nextProps.selectedCoin]);
        // this.props.setTransitionBalance(this.props.balance - nextProps.coinList[nextProps.selectedCoin]);



    }

    showBuyFeatureStakeExceeds(value: any) {
        let buyFeatureStakeExceeds = UIManager.getRef("buyFeatureStakeExceeds");
        buyFeatureStakeExceeds.visible = value;

        let totalWinTextContainer = UIManager.getRef("container_basegame_text3");

        if (this.props.displayInCoins) {
            let coinTotalWin = UIManager.getRef("coinContainer_text_totalwin_label");
            let coinTotalColon = UIManager.getRef("coinContainer_text_colonSymbol44");
            let coinTotalValue = UIManager.getRef("coinContainer_text_win_value1_desktop");
            let totalCoinwinSeparater = UIManager.getRef("coinContainer_totalCoinwinSeparater1");
            let coinContainer_coinWinText = UIManager.getRef("coinContainer_coinWinText");
            let coinContainer_totalCoinwincolon = UIManager.getRef("coinContainer_totalCoinwincolon");
            let coinContainer_coin_win_value1_desktop = UIManager.getRef("coinContainer_coin_win_value1_desktop");

            if (isMobile && window.innerHeight > window.innerWidth) {
                coinTotalWin = UIManager.getRef("coinContainer_text_totalwin_label_Portrait");
                coinTotalColon = UIManager.getRef("coinContainer_text_colonSymbol1_portrait");
                coinTotalValue = UIManager.getRef("coinContainer_text_win_value1");
                totalCoinwinSeparater = UIManager.getRef("coinContainer_totalCoinwinSeparater2");
                coinContainer_coinWinText = UIManager.getRef("coinContainer_coinWinText_portrait");
                coinContainer_totalCoinwincolon = UIManager.getRef("coinContainer_totalCoinwincolon_portrait");
                coinContainer_coin_win_value1_desktop = UIManager.getRef("coinContainer_coin_win_value1");
            }
            coinTotalWin && (coinTotalWin.visible = !value);
            coinTotalColon && (coinTotalColon.visible = !value);
            coinTotalValue && (coinTotalValue.visible = !value);
            totalCoinwinSeparater && (totalCoinwinSeparater.visible = !value);
            coinContainer_coinWinText && (coinContainer_coinWinText.visible = !value);
            coinContainer_totalCoinwincolon && (coinContainer_totalCoinwincolon.visible = !value);
            coinContainer_coin_win_value1_desktop && (coinContainer_coin_win_value1_desktop.visible = !value);
        } else {
            totalWinTextContainer && (totalWinTextContainer.visible = !value);
        }
    }

    showWin(nextProps: any, lastWinStore: any) {

        let winAmountInCurrency;
        this.storedFinalAmount = this.winValueStore;

        winAmountInCurrency = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.winValueStore, true, true, true, true));
        if (!isMobile) {

            UIManager.getRef(this.winValueText) && (UIManager.getRef(this.winValueText).visible = true);



            UIManager.getRef(this.winValueText) && (UIManager.setText(this.winValueText, winAmountInCurrency));

        }



        else if (isMobile) {

            UIManager.getRef("text_win_value1_landscape") && (UIManager.getRef("text_win_value1_landscape").visible = true);
            UIManager.getRef("text_win_value1_landscape") && (UIManager.setText("text_win_value1_landscape", winAmountInCurrency));


        }
        //else {
        //    UIManager.getRef(this.winValueText) && (UIManager.getRef(this.winValueText).visible = true);

        //}

        let coinwinContainer1: any = UIManager.getRef("container_label_coins");

        coinwinContainer1 && UIManager.alignChildren("container_label_coins", "left")

    }

    showValuesInCoins(showInCoins: any) {
        let coinContainer: any = UIManager.getRef("container_label_coins")
        let coinContainer_of_bet: any = UIManager.getRef("container_basegame_text_bet_coins")
        let coinContainerPortrait: any = UIManager.getRef("container_label_coins_portrait")

        let currencyContainer1: any = UIManager.getRef("container_basegame_text1")
        let currencyContainer2: any = UIManager.getRef("container_basegame_text2")
        let coinContainer2: any = UIManager.getRef("container_basegame_text_balance");

        let currencyContainer3: any = UIManager.getRef("container_basegame_text3")
        currencyContainer2 && UIManager.alignChildren("container_basegame_text2", "right")
        coinContainer2 && UIManager.alignChildren("container_basegame_text_balance", "right")
        if (showInCoins) {



            if (isMobile && window.innerWidth < window.innerHeight) {
                UIManager.getRef("container_basegame_text2_portrait") && (UIManager.getRef("container_basegame_text2_portrait").visible = false);

                UIManager.getRef("container_basegame_text1_portrait") && (UIManager.getRef("container_basegame_text1_portrait").visible = false);
                coinContainerPortrait && (coinContainerPortrait.visible = true)
            }
            else {
                if (showInCoins) {
                    coinContainer && (coinContainer.visible = true)
                    coinContainer_of_bet && (coinContainer_of_bet.visible = true)
                    coinContainer2 && (coinContainer2.visible = true)
                }
                currencyContainer1 && (currencyContainer1.visible = false)
                currencyContainer2 && (currencyContainer2.visible = false)
                // coinContainer2 && (coinContainer2.visible = false)

            }
            currencyContainer3 && (currencyContainer3.visible = false)


        } else {

            if (isMobile && window.innerWidth < window.innerHeight) {
                UIManager.getRef("container_basegame_text2_portrait") && (UIManager.getRef("container_basegame_text2_portrait").visible = true);

                UIManager.getRef("container_basegame_text1_portrait") && (UIManager.getRef("container_basegame_text1_portrait").visible = true);
                coinContainerPortrait && (coinContainerPortrait.visible = false)
            }
            else {

                currencyContainer1 && (currencyContainer1.visible = true)
                currencyContainer2 && (currencyContainer2.visible = true)
                coinContainer2 && (coinContainer2.visible = false)


            }
            currencyContainer3 && (currencyContainer3.visible = true)
        }

        if (!showInCoins) {
            coinContainer && (coinContainer.visible = false)
            coinContainer_of_bet && (coinContainer_of_bet.visible = false)
            coinContainer2 && (coinContainer2.visible = false)
        }
        if (isMobile && window.innerWidth < window.innerHeight) {
            this.updateValueInCoinsPortrait(this.props.selectedCoin)
        }

        if (this.props.insufficientFunds) {
            let timer = TIMER.TimerManager.createTimer(5);
            timer.on('end', (e: any) => {
                this.showInsufficientFunds(true);
            })
            timer.start();

        }
    }

    handleOnLayoutChange(showInCoins: any) {
        let coinContainer: any = UIManager.getRef("container_label_coins")
        let coinContainer_of_bet: any = UIManager.getRef("container_basegame_text_bet_coins")
        let coinContainerPortrait: any = UIManager.getRef("container_label_coins_portrait")

        let currencyContainer1: any = UIManager.getRef("container_basegame_text1");
        let coinContainer2: any = UIManager.getRef("container_basegame_text_balance");
        let currencyContainer2: any = UIManager.getRef("container_basegame_text2");
        let currencyContainer3: any = UIManager.getRef("container_basegame_text3");
        currencyContainer2 && UIManager.alignChildren("container_basegame_text2", "right")
        coinContainer2 && UIManager.alignChildren("container_basegame_text_balance", "right")
        if (showInCoins) {
            if (window.innerWidth < window.innerHeight) {
                coinContainer_of_bet && (coinContainer_of_bet.visible = false)
                coinContainer && (coinContainer.visible = false)
                coinContainerPortrait && (coinContainerPortrait.visible = true)
                currencyContainer1 && (currencyContainer1.visible = false)
                currencyContainer2 && (currencyContainer2.visible = false)
                coinContainer2 && (coinContainer2.visible = false)
                currencyContainer3 && (currencyContainer3.visible = false)
                UIManager.getRef("container_basegame_text2_portrait") && (UIManager.getRef("container_basegame_text2_portrait").visible = false);

                UIManager.getRef("container_basegame_text1_portrait") && (UIManager.getRef("container_basegame_text1_portrait").visible = false);
            } else {
                coinContainer && (coinContainer.visible = true)
                coinContainer_of_bet && (coinContainer_of_bet.visible = true)
                currencyContainer1 && (currencyContainer1.visible = false)
                currencyContainer2 && (currencyContainer2.visible = false)
                coinContainer2 && (coinContainer2.visible = true)
                currencyContainer3 && (currencyContainer3.visible = false)
            }

        }
    }

    updateValueInCoins(coinIndex: any) {
        let updatedBalance = Math.round(((this.props.balance - this.props.buyInFeatureDeductAmt * 10 / this.props.coinList[coinIndex]) * 10 / this.props.coinList[coinIndex]));
        this.totalCoins && (this.totalCoins.text = updatedBalance);
        this.totalCoins && (UIManager.setText("coinContainer_total_coins_value", updatedBalance))

        this.coinContainer_Bet && (this.coinContainer_Bet.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[coinIndex]), true, true, true, true)));
        if (isMobile) {
            this.updateValueInCoinsPortrait(coinIndex)
        }
        this.alignContainer();
    }

    updateValueInCoinsPortrait(coinIndex: any) {
        this.totalCoins = UIManager.getRef("coinContainer_total_coins_value_portrait");
        this.coinContainer_Bet = UIManager.getRef("coinContainer_text_total_bet_value_Portrait");
        let updatedBalance = Math.round(((this.props.balance - this.props.buyInFeatureDeductAmt * 10 / this.props.coinList[coinIndex]) * 10 / this.props.coinList[coinIndex]));
        this.totalCoins && UIManager.setText("coinContainer_total_coins_value_portrait", updatedBalance)
        this.coinContainer_Bet && UIManager.setText("coinContainer_text_total_bet_value_Portrait", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[coinIndex]), true, true, true, true)))
        //this.coinContainer_Bet && (this.coinContainer_Bet.text = CURRENCY.CurrencyManager.formatCurrencyString((this.props.coinList[coinIndex]), true, true, true, true));
    }

    updateWinInCoins() {
        this.coinsWon = UIManager.getRef("coinContainer_coin_win_value1_desktop");
        this.coinContainer_totalWin = UIManager.getRef("coinContainer_text_win_value1_desktop");
        let winAmountInCurrency = Math.round(this.winValueStore * 10 / this.props.coinList[this.props.currentBetIndex]);

        //UIManager.getRef(this.winValueText) && (UIManager.setText(this.winValueText , winAmountInCurrency);
        //this.coinsWon && UIManager.setText("coinContainer_text_win_value1", winAmountInCurrency.toString())
        this.coinsWon && (this.coinsWon.text = winAmountInCurrency.toString());
        UIManager.getRef("coinContainer_coin_win_value1_desktop") && (UIManager.setText("coinContainer_coin_win_value1_desktop", winAmountInCurrency))

        UIManager.getRef("coinContainer_text_win_value1_desktop") && (UIManager.setText("coinContainer_text_win_value1_desktop", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.winValueStore, true, true, true, true))));
        this.coinContainer_totalWin && (this.coinContainer_totalWin.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.winValueStore, true, true, true, true)));
        if (isMobile) {
            this.updateWinInCoinsPortrait();
        }

        let coinwinContainer1: any = UIManager.getRef("container_label_coins");

        coinwinContainer1 && UIManager.alignChildren("container_label_coins", "left")
    }
    updateWinInCoinsPortrait() {
        this.coinsWon = UIManager.getRef("coinContainer_coin_win_value1");
        this.coinContainer_totalWin = UIManager.getRef("coinContainer_text_win_value1");
        let winAmountInCurrency = Math.round(this.winValueStore * 10 / this.props.coinList[this.props.currentBetIndex]);
        this.coinsWon && UIManager.setText("coinContainer_coin_win_value1", winAmountInCurrency)
        this.coinContainer_totalWin && UIManager.setText("coinContainer_text_win_value1", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.winValueStore, true, true, true, true)))
    }



    setGameClockTime() {
        let timer = TIMER.TimerManager.createTimer(100);

        timer.on('repeat', () => {
            var today = new Date();
            let sec = today.getSeconds()
            let newSec
            if (sec < 10) {

                newSec = "0" + sec
            }
            else {
                newSec = sec
            }

            let minutes = today.getMinutes()
            let newMinutes
            if (minutes < 10) {

                newMinutes = "0" + minutes
            }
            else {
                newMinutes = minutes
            }

            var time = today.getHours() + ":" + newMinutes
            let game_clock = UIManager.getRef("game_clock");
            game_clock && (game_clock.text = time);

        });
        timer.start(true);


    }
    //  

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.spinStart !== this.props.spinStart || nextProps.selectedCoin !== this.props.selectedCoin || nextProps.allSpinComplete !== this.props.allSpinComplete || nextProps.layoutMode !== this.props.layoutMode
            || nextProps.allButtonEnable !== this.props.allButtonEnable || nextProps.currentBetIndex != this.props.currentBetIndex || nextProps.winAmount != this.props.winAmount
            || nextProps.winAmountEmpty != this.props.winAmountEmpty
            || nextProps.totalCreditWinAmount != this.props.totalCreditWinAmount
            || nextProps.fgSpinWinAmount != this.props.fgSpinWinAmount
            || nextProps.displayInCoins != this.props.displayInCoins
            || nextProps.basegamestate != this.props.basegamestate
            || nextProps.isRequestSent != this.props.isRequestSent
            || nextProps.insufficientFunds != this.props.insufficientFunds
            || nextProps.buyFeatureStakeExceeds != this.props.buyFeatureStakeExceeds
            || nextProps.buyInFeatureDeductAmt != this.props.buyInFeatureDeductAmt
            || nextProps.balance != this.props.balance
            || nextProps.sessionTimer != this.props.sessionTimer
            || nextProps.callFlowManager != this.props.callFlowManager
            || nextProps.hasCapped !== this.props.hasCapped
            || nextProps.blastStart != this.props.blastStart) {

            if (nextProps.sessionTimer != this.props.sessionTimer) {
                // let game_session = UIManager.getRef("game_session");
                // game_session && (game_session.text = nextProps.sessionTimer);
            }
            if (nextProps.insufficientFunds && nextProps.insufficientFunds != this.props.insufficientFunds) {
                this.showInsufficientFunds(true);
            }

            if (!nextProps.insufficientFunds && nextProps.insufficientFunds != this.props.insufficientFunds) {
                this.showInsufficientFunds(false);
            }

            if (nextProps.buyFeatureStakeExceeds && nextProps.buyFeatureStakeExceeds != this.props.buyFeatureStakeExceeds) {
                this.showBuyFeatureStakeExceeds(nextProps.buyFeatureStakeExceeds);
            }
            if (!nextProps.buyFeatureStakeExceeds && nextProps.buyFeatureStakeExceeds != this.props.buyFeatureStakeExceeds) {
                this.showBuyFeatureStakeExceeds(nextProps.buyFeatureStakeExceeds);
            }

            if (nextProps.balance !== this.props.balance) {
                let balanceValueInCurrency = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(nextProps.balance, true, true, true, true));

                if (isMobile) {
                    if (window.innerWidth < window.innerHeight) {
                        // UIManager.getRef("text_Balance_value_withSign_portrait") && (UIManager.setText("text_Balance_value_withSign_portrait", balanceValueInCurrency));
                    }
                    else {
                        // UIManager.getRef("text_Balance_value_withSign_landscape") && (UIManager.setText("text_Balance_value_withSign_landscape", balanceValueInCurrency));
                        this.alignContainer();
                    }

                }
                else {
                    if (!nextProps.inFreeGame) {
                        // UIManager.getRef(this.balanceValueText) && (UIManager.setText(this.balanceValueText, balanceValueInCurrency));
                        this.alignContainer();
                    }
                }
                this.updateValueInCoins(nextProps.selectedCoin);
            }
            if (nextProps.buyInFeatureDeductAmt > 0 && nextProps.buyInFeatureDeductAmt !== this.props.buyInFeatureDeductAmt) {
                this.winValueStore = 0;
                this.showWin(nextProps, this.winValueStore);
                //let balanceValueInCurrency = CURRENCY.CurrencyManager.formatCurrencyString(nextProps.balance - nextProps.buyInFeatureDeductAmt * nextProps.coinList[nextProps.selectedCoin], true, true, true, true);
                let balanceValueInCurrency = this.correctCurrencyCodeXAF(this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(nextProps.balance - nextProps.buyInFeatureDeductAmt, true, true, true, true)));

                if (isMobile) {
                    if (window.innerWidth < window.innerHeight) {
                        UIManager.getRef("text_Balance_value_withSign_portrait") && (UIManager.setText("text_Balance_value_withSign_portrait", balanceValueInCurrency));
                    }
                    else {
                        UIManager.getRef("text_Balance_value_withSign_landscape") && (UIManager.setText("text_Balance_value_withSign_landscape", balanceValueInCurrency));
                        this.alignContainer();
                    }

                }
                else {
                    if (!nextProps.inFreeGame) {
                        UIManager.getRef(this.balanceValueText) && (UIManager.setText(this.balanceValueText, balanceValueInCurrency));
                        this.alignContainer();
                    }
                }
                this.updateValueInCoins(nextProps.selectedCoin);
                //this.props.setApplicationBalance(nextProps.balance - nextProps.buyInFeatureDeductAmt * nextProps.coinList[nextProps.selectedCoin]);
                this.props.setApplicationBalance(nextProps.balance - nextProps.buyInFeatureDeductAmt);
            }
            if (nextProps.allButtonEnable && nextProps.allButtonEnable !== this.props.allButtonEnable) {
                let balanceValueInCurrency = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(nextProps.balance, true, true, true, true));

                if (isMobile) {
                    if (window.innerWidth < window.innerHeight) {
                        UIManager.getRef("text_Balance_value_withSign_portrait") && (UIManager.setText("text_Balance_value_withSign_portrait", balanceValueInCurrency));
                    }
                    else {
                        UIManager.getRef("text_Balance_value_withSign_landscape") && (UIManager.setText("text_Balance_value_withSign_landscape", balanceValueInCurrency));

                    }
                    this.alignContainer();
                }
                else {
                    if (!nextProps.inFreeGame) {
                        if (this.props.hasBalance) {
                            let amount, finalDisplayAmount;
                            amount = nextProps.balance + nextProps.addOnBalance;
                            finalDisplayAmount = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(amount, true, true, true, true));
                            UIManager.getRef(this.balanceValueText) && (UIManager.setText(this.balanceValueText, finalDisplayAmount));
                            nextProps.setApplicationBalance(amount);
                        }
                        else {
                            UIManager.getRef(this.balanceValueText) && (UIManager.setText(this.balanceValueText, balanceValueInCurrency));
                        }

                        this.props.hasBalanceOrEmpty(false);
                        this.alignContainer();
                    }
                }
                this.updateValueInCoins(nextProps.selectedCoin);
                //this.props.setApplicationBalance(nextProps.transitionBalance);
            }


            if (nextProps.displayInCoins != this.props.displayInCoins) {
                this.showValuesInCoins(nextProps.displayInCoins);

            }
            if (nextProps.hasCapped) {
                if (this.props.inFreeGame) {
                    this.winValueStore = nextProps.fgSpinWinAmount;
                }
                else {
                    this.winValueStore = nextProps.winAmount;
                }
                this.showWin(nextProps, this.winValueStore);
                this.updateWinInCoins();
            }
            if (nextProps.spinStart) {
                this.winValueStore = 0;
                //UIManager.getRef(this.winValueText) && (UIManager.getRef(this.winValueText).visible = false);
                this.updateValues(nextProps);
                if (!this.props.inFreeGame) {

                    this.showWin(nextProps, nextProps.winAmount);
                    this.updateWinInCoins();
                }

                this.updateValueInCoins(nextProps.selectedCoin);
            }







            if (nextProps.callFlowManager && nextProps.callFlowManager != this.props.callFlowManager) {
                if (nextProps.basegamestate) {






                }
            }
            if (nextProps.blastStart && nextProps.blastStart != this.props.blastStart) {


                if (nextProps.winAmount !== 0) {
                    let timer = TIMER.TimerManager.createTimer(210);
                    timer.on('end', (e: any) => {
                        this.winValueStore = nextProps.winAmount;
                        this.showWin(nextProps, nextProps.winAmount);
                        this.updateWinInCoins();
                        if (this.props.inFreeGame) {
                            this.winValueStore = nextProps.fgSpinWinAmount;
                            this.showWin(nextProps, this.winValueStore);
                            this.updateWinInCoins();
                        }
                    })
                    timer.start();

                } else {
                    this.winValueStore = 0;
                }
            }
            if (nextProps.winAmountEmpty) {
                //UIManager.getRef(this.winValueText) && (UIManager.getRef(this.winValueText).visible = false);
                this.props.setWinAmount(false);
            }
            if (nextProps.winAmount !== this.props.winAmount && nextProps.allSpinComplete) {
                // commented because blastStart condition will be called now every time when blast happens
                //  this.winValueStore = nextProps.winAmount;
                //  this.showWin(nextProps, this.winValueStore);
                //  this.updateWinInCoins();
                //  if (this.props.inFreeGame) {
                //      this.winValueStore = nextProps.fgSpinWinAmount;
                //      this.showWin(nextProps, this.winValueStore);
                //      this.updateWinInCoins();
                //  }
            }
            if (nextProps.fgSpinWinAmount !== this.props.fgSpinWinAmount && nextProps.allSpinComplete) {
                if (this.props.inFreeGame) {
                    this.winValueStore = nextProps.fgSpinWinAmount;
                    this.showWin(nextProps, this.winValueStore);
                    this.updateWinInCoins();
                }

            }
            if (nextProps.selectedCoin !== this.props.selectedCoin) {
                this.betValueText && (this.betValueText.text = CURRENCY.CurrencyManager.formatCurrencyString((nextProps.coinList[nextProps.selectedCoin]), true, true, true, true));
                //this.totalTetValueText && (this.totalTetValueText.text = CURRENCY.CurrencyManager.formatCurrencyString((nextProps.coinList[nextProps.selectedCoin]), true, true, true, true));
                if (isMobile) {
                    if (window.innerWidth < window.innerHeight) {
                        UIManager.getRef("text_total_bet_value_portrait") && (UIManager.setText("text_total_bet_value_portrait", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((nextProps.coinList[nextProps.selectedCoin]), true, true, true, true))));

                    } else {

                        UIManager.getRef("text_total_bet_value_landscape") && (UIManager.setText("text_total_bet_value_landscape", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((nextProps.coinList[nextProps.selectedCoin]), true, true, true, true))));
                    }
                } else {

                    UIManager.getRef("text_total_bet_value") && (UIManager.setText("text_total_bet_value", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((nextProps.coinList[nextProps.selectedCoin]), true, true, true, true))));
                }
                UIManager.getRef("label_BetPanel_value") && (UIManager.setText("label_BetPanel_value", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((nextProps.coinList[nextProps.selectedCoin]), true, true, true, true))));
                UIManager.getRef("coinContainer_text_total_bet_value") && (UIManager.setText("coinContainer_text_total_bet_value", this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((nextProps.coinList[nextProps.selectedCoin]), true, true, true, true))));

                //this.betPanelLableValue && (this.betPanelLableValue.text = CURRENCY.CurrencyManager.formatCurrencyString((nextProps.coinList[nextProps.selectedCoin]), true, true, true, true));
                this.updateValueInCoins(nextProps.selectedCoin);

                UIManager.getRef("text_Coin_value_value") && (UIManager.getRef("text_Coin_value_value").text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(nextProps.coinList[nextProps.selectedCoin] / this.coinValueDivider, true, true, true, true)));
            }


            if (nextProps.currentBetIndex !== this.props.currentBetIndex) {
                this.betValueText && (this.betValueText.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.betList[nextProps.currentBetIndex]), true, true, true, true)));
                this.betPanelLableValue && (this.betPanelLableValue.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.betList[nextProps.currentBetIndex]), true, true, true, true)));
                this.updateValueInCoins(nextProps.currentBetIndex);




                if (isMobile) {
                    if (window.innerWidth < window.innerHeight) {
                        (UIManager.getRef("text_total_bet_value_portrait").text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.betList[nextProps.currentBetIndex]), true, true, true, true)));

                    }
                    else {
                        (UIManager.getRef("text_total_bet_value_landscape").text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.betList[nextProps.currentBetIndex]), true, true, true, true)));

                    }

                }
                else {
                    this.totalTetValueText && (this.totalTetValueText.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.betList[nextProps.currentBetIndex]), true, true, true, true)));

                }


            }
            if (nextProps.layoutMode !== this.props.layoutMode) {
                this.layoutChange(nextProps.layoutMode);
            }
            if (nextProps.basegamestate && nextProps.basegamestate != this.props.basegamestate) {
                if ((nextProps.totalCreditWinAmount / 100) >= this.winCelebrationMinimumValue * this.props.betList[this.props.currentBetIndex] / 100) {
                    // nextProps.winCelebrationShow(true);
                    // nextProps.winCelebrationStart(true, "Cash");
                    // nextProps.setAllButtonDisable();
                }
                //UIManager.getRef(this.winValueText) && (UIManager.getRef(this.winValueText).visible = false);
            }
            return false;
        }
        if (nextProps.leftMessageIndex !== this.props.leftMessageIndex || nextProps.rightMessageIndex !== this.props.rightMessageIndex) {
            this.leftContainerChildCurrentIndex = nextProps.leftMessageIndex;
            this.rightContainerChildCurrentIndex = nextProps.rightMessageIndex;
        }
        if (nextProps.startInterval && nextProps.startInterval !== this.props.startInterval) {
            this.startInterval(nextProps);
        }
        if (nextState.leftContainer !== this.state.leftContainer) {
            this.leftContainerChanging();
        }

        if (nextState.rightContainer !== this.state.rightContainer) {
            this.rightContainerChanging(nextState);
        }
        if (nextProps.pauseInterval && nextProps.pauseInterval !== this.props.pauseInterval) {
            this.pauseInterval(nextProps);
        }

        if (nextProps.resumeInterval !== this.props.resumeInterval) {
            this.resumeInterval(nextProps);

        }

        return false;
    }

    showInsufficientFunds(value: boolean) {
        let funds = UIManager.getRef("insufficientFunds");
        let funds1 = UIManager.getRef("backgroundGraphic_for_insufficientFunds");
        let totalWinTextContainer = UIManager.getRef("container_basegame_text3");
        funds && (funds.visible = value);
        funds1 && (funds1.visible = value);

        if (this.props.displayInCoins) {
            let coinTotalWin = UIManager.getRef("coinContainer_text_totalwin_label");
            let coinTotalColon = UIManager.getRef("coinContainer_text_colonSymbol44");
            let coinTotalValue = UIManager.getRef("coinContainer_text_win_value1_desktop");
            let totalCoinwinSeparater = UIManager.getRef("coinContainer_totalCoinwinSeparater1");
            let coinContainer_coinWinText = UIManager.getRef("coinContainer_coinWinText");
            let coinContainer_totalCoinwincolon = UIManager.getRef("coinContainer_totalCoinwincolon");
            let coinContainer_coin_win_value1_desktop = UIManager.getRef("coinContainer_coin_win_value1_desktop");

            if (isMobile && window.innerHeight > window.innerWidth) {
                coinTotalWin = UIManager.getRef("coinContainer_text_totalwin_label_Portrait");
                coinTotalColon = UIManager.getRef("coinContainer_text_colonSymbol1_portrait");
                coinTotalValue = UIManager.getRef("coinContainer_text_win_value1");
                totalCoinwinSeparater = UIManager.getRef("coinContainer_totalCoinwinSeparater2");
                coinContainer_coinWinText = UIManager.getRef("coinContainer_coinWinText_portrait");
                coinContainer_totalCoinwincolon = UIManager.getRef("coinContainer_totalCoinwincolon_portrait");
                coinContainer_coin_win_value1_desktop = UIManager.getRef("coinContainer_coin_win_value1");
            }
            coinTotalWin && (coinTotalWin.visible = !value);
            coinTotalColon && (coinTotalColon.visible = !value);
            coinTotalValue && (coinTotalValue.visible = !value);
            totalCoinwinSeparater && (totalCoinwinSeparater.visible = !value);
            coinContainer_coinWinText && (coinContainer_coinWinText.visible = !value);
            coinContainer_totalCoinwincolon && (coinContainer_totalCoinwincolon.visible = !value);
            coinContainer_coin_win_value1_desktop && (coinContainer_coin_win_value1_desktop.visible = !value);
        } else {
            totalWinTextContainer && (totalWinTextContainer.visible = !value);
        }
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        this.bindUI();


    }


    render() {

        return (
            <UIManager id={"gamePlayerMessageContainer"} type={"Container"} ref={i => this.gamePlayerMessageContainer = i}
                app={this.app}>
                <UIManager id={"playerMessage"} type={"Container"} name={"playerMessage"} app={this.app}>
                    {
                        this.displayUI && this.displayUI.map((i: any) =>
                            <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                                id={i.id} {...i} app={this.app} />
                        )
                    }
                </UIManager>
            </UIManager>
        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'asyncServerAction' | 'flowManagerState' | 'freegameState' | 'basegameState' | 'applicationState' | 'playerMessageState' | 'gridsState' | 'betPanelState' | 'buttonPanelState' | 'behaviourState' | 'asyncGameLevelSeverState'>, ownProps?: any): IStateToProps =>
    ({
        layoutMode: state.applicationState.layoutMode,
        selectContainer: state.playerMessageState.selectContainer,
        leftMessageIndex: state.playerMessageState.leftMessageIndex,
        rightMessageIndex: state.playerMessageState.rightMessageIndex,
        startInterval: state.playerMessageState.startInterval,
        pauseInterval: state.playerMessageState.pauseInterval,
        resumeInterval: state.playerMessageState.resumeInterval,
        leftContainerIntervalTime: state.playerMessageState.leftContainerIntervalTime,
        rightContainerIntervalTime: state.playerMessageState.rightContainerIntervalTime,
        spinStart: state.gridsState.spinStart,
        allSpinComplete: state.gridsState.allSpinComplete,
        betList: state.basegameState.betList,
        currentBetIndex: state.betPanelState.selectedCoin,
        selectedCoin: state.betPanelState.selectedCoin,
        coinList: state.betPanelState.coinList,
        winAmount: state.basegameState.winAmount,
        balance: state.basegameState.balance,
        basegamestate: state.basegameState.basegamestate,
        allButtonEnable: state.buttonPanelState.allButtonEnable,
        transitionBalance: state.behaviourState.transitionBalance,
        previousBalance: state.behaviourState.previousBalance,
        increaseBetResult: state.asyncGameLevelSeverState.result,
        winAmountEmpty: state.behaviourState.winAmountEmpty,
        displayInCoins: state.behaviourState.displayInCoins,
        totalCreditWinAmount: state.behaviourState.totalCreditWinAmount,
        fgSpinWinAmount: state.behaviourState.fgSpinWinAmount,
        buyInFeatureDeductAmt: state.behaviourState.buyInFeatureDeductAmt,
        insufficientFunds: state.behaviourState.insufficientFunds,
        buyFeatureStakeExceeds: state.behaviourState.buyFeatureStakeExceeds,
        sessionTimer: state.behaviourState.sessionTimer,
        callFlowManager: state.flowManagerState.callFlowManager,
        inFreeGame: state.freegameState.inFreeGame,
        isRequestSent: state.asyncServerAction.isRequestSent,
        blastStart: state.gridsState.blastStart,
        hasBalance: state.behaviourState.hasBalance,
        addOnBalance: state.behaviourState.addOnBalance,
        hasCapped: state.behaviourState.hasCapped,
    }),
    (dispatch: Dispatch, ownProps): IDispatchToProps => ({
        setApplicationBalance: (balance: number): any => dispatch(basegameActions.setApplicationBalance(balance)),

        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        setPreviousBalance: (previousBalance: any): any => dispatch(behaviourAction.setPreviousBalance(previousBalance)),
        pauseTheInterval: (pauseInterval: boolean, leftMessageIndex: number, rightMessageIndex: number, selectContainer: string): any => dispatch(showMessageActions.pauseTheInterval(pauseInterval, leftMessageIndex, rightMessageIndex, selectContainer)),
        setWinAmount: (winAmountEmpty: any): any => dispatch(behaviourAction.setWinAmount(winAmountEmpty)),
        winCelebrationStart: (startWinCelebration: boolean, showAmount: string): any => dispatch(winCelebrationActions.winCelebrationStart(startWinCelebration, showAmount)),
        winCelebrationShow: (showWinCelebration: boolean): any => dispatch(winCelebrationActions.winCelebrationShow(showWinCelebration)),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        setTransitionBalance: (transitionBalance: any): any => dispatch(behaviourAction.setTransitionBalance(transitionBalance)),
        hasBalanceOrEmpty: (hasBalance: boolean): any => dispatch(behaviourAction.hasBalanceOrEmpty(hasBalance)),


    }))(withPlayerMessageConfiguration(GamePlayerMessage)));